<template>
  <div class="main-background">
    <div class="noresult-screen-full">
      <button class="main-back-button" @click="goToMainPage">
        <chevron-left-icon class="main-back-button-icon" />
      </button>
      <div
        class="input-group"
        :style="
          isShowProducts !== 'products' ? { width: '70%' } : { width: '80%' }
        "
      >
        <search-icon class="search-input-icon" />
        <input
          v-if="searchLocalText"
          v-focus
          type="text"
          placeholder="Пошук"
          v-model="searchLocalText"
          class="form-control search-text"
          id="search-input"
        />
        <input
          v-else
          type="text"
          placeholder="Пошук"
          v-model="searchLocalText"
          class="form-control search-text"
          id="search-input"
        />
      </div>
      <div class="search-filter">
        <div v-if="isShowProducts !== 'products'" class="search-filter-btn">
          <button class="filter-button" @click="setIsOpenFilterPage">
            <sliders-icon class="filter-button-icon" />
          </button>
        </div>
      </div>
    </div>

    <div v-if="isShowProducts !== 'category'" class="filter-category-list">
      <div
        class="filter-category-item"
        :style="[
          usedCategories.id === category.id && {
            background: '#333',
            color: '#fff',
          },
        ]"
        @click="setClickToHeaderCategory(category)"
        v-for="category of allCategories"
        :key="category.id"
      >
        {{ category.name }}
      </div>
    </div>
    <p v-if="searchLocalText" class="product-used-title">
      {{ `Результат пошуку "${searchLocalText}"` }}
    </p>
    <div v-if="isShowProducts === 'products'" class="sort-filter-container">
      <button class="small-filter-button" @click="setIsOpenFilterPage">
        <sliders-icon class="small-filter-button-icon" />
        Фільтр
        <span
          v-if="Object.keys(getFilterParametrs).length"
          class="used-filter-length"
          >{{ `(+${getFilterCounter(getFilterParametrs)})` }}</span
        >
      </button>
      <div class="main-sort-container">
        <div class="product-sort-list-button" @click="setIsOpenSortList">
          {{ usedSort ? usedSort : "Сортувати за" }}
          <chevron-down-icon class="sort-button-icon" />
        </div>
        <div v-if="isOpenSortList" class="sort-items-container">
          <p
            class="sort-items"
            v-for="list of sortList"
            :key="list.id"
            @click="isStartSort(list)"
          >
            {{ list.name }}
          </p>
        </div>
      </div>
    </div>
    <h2 v-if="isShowProducts === 'category'" class="category-used-title">
      Категорії
    </h2>
    <div v-if="isShowProducts === 'category'" class="category-container">
      <div
        v-for="category of allCategories"
        :key="category.id"
        class="category-block"
        @click="setClickToCategory(category)"
      >
        <img :src="category.img" :alt="category.name" class="categoty-image" />
        <div class="categoty-name-container">
          <p class="categoty-name">{{ category.name }}</p>
        </div>
      </div>
    </div>
    <h2 v-if="isShowProducts === 'preCategory'" class="category-used-title">
      {{ usedCategories.name }}
    </h2>
    <div v-if="isShowProducts === 'preCategory'" class="category-container">
      <div
        v-for="category of preCategories.children || preCategories"
        :key="category.id"
        class="category-block"
        @click="setClickToPreCategories(category)"
      >
        <img :src="category.img" :alt="category.name" class="categoty-image" />
        <div class="categoty-name-container">
          <p class="categoty-name">{{ category.name }}</p>
        </div>
      </div>
    </div>
    <div v-if="isShowProducts === 'products'" class="category-container">
      <div
        v-for="product of getProducts.products || getProducts"
        :key="product.id"
        class="product-block"
        @click="setClickToProduct(product)"
      >
        <img :src="product.img" :alt="product.name" class="product-image" />
        <div class="product-name-container">
          <p class="product-name">{{ product.name }}</p>
          <p class="product-price">{{ `${product.price} грн.` }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SlidersIcon, ChevronDownIcon, SearchIcon } from "vue-feather-icons";
import { mapMutations } from "vuex";
import { ChevronLeftIcon } from "vue-feather-icons";

export default {
  name: "product-page",
  components: {
    SlidersIcon,
    SearchIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
  },
  props: {},
  data() {
    return {
      usedCategories: {},
      categoryItems: [],
      productItemsElements: [],
      searchLocalText: "",
      isOpenSortList: false,
      usedSort: "",
      sortList: [
        { id: 1, name: "А-Я", value: "name" },
        { id: 2, name: "Я-А", value: "-name" },
        { id: 3, name: "Зростанням ціни", value: "price" },
        { id: 4, name: "Спаданням ціни", value: "-price" },
      ],
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.searchLocalText = this.getSearchText;
  },
  computed: {
    allCategories() {
      return this.$store.getters.allCategories;
    },
    isShowProducts() {
      return this.$store.getters.isShowProducts;
    },
    preCategories() {
      return this.$store.getters.preCategories;
    },
    getProducts() {
      return this.$store.getters.getProducts;
    },
    getSearchText() {
      return this.$store.getters.getSearchText;
    },
    getFilterParametrs() {
      return this.$store.getters.getFilterParametrs;
    },
    getCheckedCategory() {
      return this.$store.getters.getCheckedCategory;
    },
  },
  methods: {
    ...mapMutations([
      "setIsShowProducts",
      "setIsOpenProductInfo",
      "setAddPerCategory",
      "setChangeSearchText",
      "addPerPage",
      "setCheckedCategory",
    ]),
    activeProductSearch() {
      if (this.searchLocalText.length < 3) {
        return;
      }
      try {
        let data = {
          q: this.searchLocalText,
          category_ids: null,
          price_from: 0,
          price_to: 999999,
        };
        this.$store.dispatch("searchedProducts", data);
        this.$emit("setIsChangePage", "product");
      } catch (error) {
        console.log(error.message);
      }
    },
    goToMainPage() {
      this.setChangeSearchText("");
      this.$emit("setIsChangePage", "home");
    },
    isStartSort(sort) {
      this.usedSort = sort.name;
      this.isOpenSortList = false;
      let data;
      if (
        this.getCheckedCategory &&
        this.isShowProducts === "products" &&
        !this.getFilterParametrs?.category_ids
      ) {
        data = {
          category_ids: [this.getCheckedCategory.id],
          price_from: 0,
          price_to: 99999,
          sort: sort.value,
        };
      }
      if (this.getFilterParametrs?.category_ids) {
        data = {
          ...this.getFilterParametrs,
          sort: sort.value,
        };
      }
      if (
        !this.getCheckedCategory &&
        !this.getFilterParametrs?.category_ids &&
        this.getFilterParametrs.price_to
      ) {
        data = {
          ...this.getFilterParametrs,
          sort: sort.value,
        };
      }
      this.$store.dispatch("searchedProducts", data);
    },

    setIsOpenFilterPage() {
      this.addPerPage("product");
      this.$emit("setIsChangePage", "filter");
    },

    setClickToHeaderCategory(value) {
      this.usedCategories = value;
      try {
        this.$store.dispatch("getProductsReq", value.id);
      } catch (error) {
        console.log(error.message);
      }
    },

    setClickToCategory(value) {
      if (value?.children.length) {
        this.usedCategories = value;
        this.setAddPerCategory(value.children);
        this.setIsShowProducts("preCategory");
      } else {
        try {
          this.$store.dispatch("getProductsReq", value.id);
        } catch (error) {
          console.log(error.message);
        }
      }
    },
    getFilterCounter(value) {
      let counter = value.category_ids?.length || 0;
      return Object.keys(value)?.length - 1 + counter;
    },
    setClickToPreCategories(value) {
      this.setCheckedCategory(value);
      this.$store.dispatch("getProductsReq", value.id);
    },

    setClickToProduct(value) {
      this.$emit("setIsOpenProductPage");
      this.setIsOpenProductInfo(value);
    },

    setIsOpenSortList() {
      this.isOpenSortList = !this.isOpenSortList;
    },
  },
  watch: {
    searchLocalText(newValue, oldValue) {
      let val = oldValue;
      val;
      if (!newValue.length) {
        if (!this.getCheckedCategory) {
          this.$emit("setIsChangePage", "home");
        } else {
          this.setIsShowProducts("category");
        }
      }
      this.setChangeSearchText(newValue);
      this.activeProductSearch();
    },
    preCategories(newValue, oldValue) {
      let val = oldValue;
      val;
      if (this.usedCategories.id !== newValue.id) {
        this.usedCategories = newValue;
      }
    },
    getProducts(newValue, oldValue) {
      let val = oldValue;
      val;
      if (this.usedCategories.id !== newValue.id) {
        this.usedCategories = newValue;
      }
    },
  },
};
</script>

<style scoped>
.main-background {
  background: #fff;
  padding: 16px;
}
.category-used-title {
  margin-top: 8px;
  color: #333;
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}
.category-container {
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
  margin-top: 16px;
}

.category-block {
  width: 160px;
  border-radius: 12px;
  border: 2px solid #d2d6db;
  background: #01bace;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.categoty-image {
  width: 100%;
  height: 160px;
  border-radius: 10px 10px 0px 0px;
  border-bottom: 2px solid #d2d6db;
}

.categoty-name-container {
  padding: 4px;
  display: flex;
  text-align: center;
  margin: auto;
}

.categoty-name {
  margin: 0 auto;
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.product-block {
  width: 160px;
  border-radius: 12px;
  border: 2px solid #d2d6db;
  background: #f3f4f6;
  cursor: pointer;
}
.product-image {
  width: 100%;
  height: 160px;
  border-radius: 10px 10px 0px 0px;
  border-bottom: 2px solid #d2d6db;
}
.product-name-container {
  padding: 7px;
}
.product-name {
  color: #333;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
}
.product-price {
  color: #01bace;
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.product-used-title {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-top: 24px;
}

.small-filter-button-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  vertical-align: bottom;
}

.sort-filter-container {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
.small-filter-button {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  cursor: pointer;
}

.product-sort-list-button {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  cursor: pointer;
}
.sort-button-icon {
  vertical-align: bottom;
  width: 18px;
  height: 18px;
}

.main-sort-container {
  position: relative;
}

.sort-items-container {
  position: absolute;
  border: 1px solid #d2d6db;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  min-width: 150px;
  top: 40px;
  padding: 10px;
  max-height: 150px;
  overflow: auto;
}

.sort-items {
  padding: 5px 0;
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  transition: all 250 ease;
  cursor: pointer;
}

.sort-items:hover {
  background-color: #e1e2e4;
  border-radius: 5px;
}

.used-filter-length {
  color: #01bace;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  margin-left: 2px;
}

.noresult-screen-full {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 70%;
}
.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.form-control {
  padding: 8px 15px;
  border: 1px solid #eee;
  line-height: 22px;
  border-radius: 5px;
  font-size: 13px;
  color: #999;
}

input:focus,
input:active,
.form-control:focus,
.form-control:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #eee;
  color: #777;
}

.search-text {
  background: #f0f0f0 !important;
  padding: 12px;
  border: none;
  color: #000;
  font-family: "Space Grotesk", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  padding-left: 50px;
}

.search-text::placeholder {
  color: #707070;
  font-family: "Space Grotesk", sans-serif;
}

.search-iconn:focus-visible,
.search-text:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-filter-btn a {
  border-radius: 8px;
  background: #ff4c3b;
  padding: 12px;
  display: inline-block;
}

.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.filter-button-icon {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  color: #fff;
}

.filter-button {
  width: 48px;
  height: 48px;
  background: #01bace;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  background: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

.main-back-button {
  position: relative;
  background: #f0f0f0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.main-back-button-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
